export class LocalUserDataModel {
  public UserEMail: string;
  public RememberMe: boolean;
  public JwtToken: any;
  public FullName: string;
  public UserRoles: string[];
  public IsAuthenticated: boolean;
}
